import type { ListBuilderList } from '../../../types';
import {
	createItemColumn,
	createItemNumberColumn,
	createRecommendationImageColumn,
	createRecommendationMatchColumn,
	createRecommendationPriceColumn,
	createRecommendationRankColumn,
	createRecommendationReasonColumn,
} from '../columns';

/**
 * Recommended Items list configuration (PD-14016/14017)
 *
 * One ranked list with a plain-English reason per item, served from the
 * nightly account-recommender precompute (client_item_recommendation).
 * Replaces the old five-star factor grid (removed in PD-14018) that
 * surfaced effectively the whole catalog and was ignored by users.
 *
 * ClientItemHistory.tsx routes this list's queries to
 * getClientRecommendedItems (the precompute read path) via the
 * `viewType: 'recommended'` filter rule.
 */
export const recommendedList: ListBuilderList = {
	id: 'client-item-recommended',
	cacheTTL: 600000,
	name: 'Recommended',
	type: 'custom',
	active: true,
	filterRules: {
		viewType: { defaultValue: 'recommended' },
	},
	columns: [
		createRecommendationRankColumn(),
		createRecommendationImageColumn(),
		createItemColumn(),
		createItemNumberColumn(),
		createRecommendationReasonColumn(),
		createRecommendationMatchColumn(),
		createRecommendationPriceColumn(),
	],
	searchEnabled: true,
	searchPlaceholder: 'Search recommended items...',
	sortOrder: 3,
};
